var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProduct(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "gridicons:product"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M22.0526 2H1V8.31579H2.05263V19.8947C2.05263 20.4531 2.27444 20.9886 2.66925 21.3834C3.06406 21.7782 3.59954 22 4.15789 22H18.8947C19.4531 22 19.9886 21.7782 20.3834 21.3834C20.7782 20.9886 21 20.4531 21 19.8947V8.31579H22.0526V2ZM3.10526 4.10526H19.9474V6.21053H3.10526V4.10526ZM18.8947 19.8947H4.15789V8.31579H18.8947V19.8947ZM8.36842 10.4211H14.6842C14.6842 10.9794 14.4624 11.5149 14.0676 11.9097C13.6728 12.3045 13.1373 12.5263 12.5789 12.5263H10.4737C9.91533 12.5263 9.37985 12.3045 8.98504 11.9097C8.59023 11.5149 8.36842 10.9794 8.36842 10.4211Z",
    fill: "#202020"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProduct);
export default __webpack_public_path__ + "static/media/product.d3edcae5c42caf56d781cfe103aa97ef.svg";
export { ForwardRef as ReactComponent };